import { Link } from "react-router-dom";
import "../../styles/art/BrandIntroSection.css";

function BrandIntroSection() {
  return (
    <section className="brand-intro-section">
      <div className="brand-intro-section__container">
        <h2 className="brand-intro-section__title"> MỸ THUẬT DESIGN24</h2>
        <div className="brand-intro-section__underline" />
        <p className="brand-intro-section__description">
          <strong>Hệ thống đào tạo mỹ thuật thiếu nhi Design24</strong> là một
          trong những thương hiệu hàng đầu trong ngành giáo dục mỹ thuật ứng
          dụng tại Việt Nam, với chương trình đào tạo dành cho các học viên từ
          3,5 đến 16 tuổi dựa trên nền tảng Giáo dục Quốc tế Singapore. Với mong
          muốn mọi trẻ em đều được phát triển tính cách tốt cùng lối suy nghĩ
          logic vấn đề, tư duy sáng tạo thông qua học vẽ.
        </p>
        <Link
          to="/art/about"
          className="brand-intro-section__button"
        >
          Xem thêm
        </Link>
      </div>
    </section>
  );
}

export default BrandIntroSection;
